<template>
	<PCard class="my-3">
		<template #title>
			<!-- <div class="flex align-items-center justify-content-between">
        <WSubTitle text="Net Electrical Energy Actual Exp" />
      </div> -->
		</template>
		<template #content>
			<div class="flex flex-row flex-wrap justify-content-start align-items-center mt-2 mb-3">
				<PFloatLabel>
					<PCalendar
						:manualInput="false"
						:showOnFocus="true"
						class="mx-2"
						hourFormat="24"
						iconDisplay="input"
						inputId="dateFrom"
						showIcon
						style="width: 230px"
						showTime
						v-model="dateFrom"
						@date-select="changeEnergyFrom"
					/>
					<label
						class="ml-1 font-bold"
						for="dateFrom"
					>From</label>
				</PFloatLabel>
				<PFloatLabel>
					<PCalendar
						:manualInput="false"
						:showOnFocus="true"
						class="mx-2"
						hourFormat="24"
						iconDisplay="input"
						inputId="dateTo"
						showIcon
						style="width: 230px"
						showTime
						v-model="dateTo"
						@date-select="changeEnergyTo"
					/>
					<label
						class="ml-1 font-bold"
						for="dateTo"
					>To</label>
				</PFloatLabel>
			</div>

			<div id="chart">
				<apexchart
					type="area"
					height="350"
					:options="chartOptions"
					:series="series"
				></apexchart>
			</div>
		</template>
	</PCard>
</template>

<script>
import {defineComponent, Events} from 'vue'

export default defineComponent({
	props: ['title', 'data'],
	data() {
		return {
			GPOAiData: [],
			dateFrom: '',
			dateTo: '',

			// xMin: new Date('2024-12-18 16:00').getTime(),
			// xMax: new Date('2024-12-18 20:00').getTime(),
		}
	},
	computed: {
		series() {
			return [
				{
					name: 'GPOAi',
					data: this.GPOAiData,
				},
			]
		},
		chartOptions() {
			return {
				chart: {
					type: 'area',
					stacked: false,
					height: 350,
					zoom: {
						type: 'x',
						enabled: true,
						autoScaleYaxis: true,
					},
					toolbar: {
						autoSelected: 'zoom',
					},
				},
				dataLabels: {
					enabled: false,
				},
				markers: {
					size: 0,
				},
				fill: {
					type: 'gradient',
					gradient: {
						shadeIntensity: 1,
						inverseColors: false,
						opacityFrom: 0.5,
						opacityTo: 0,
						stops: [0, 90, 100],
					},
				},
				yaxis: {
					title: {
						text: 'GPOAi',
					},
					max: 1,
				},
				xaxis: {
					type: 'datetime',
					min: this.xMin,
					max: this.xMax,
				},
				tooltip: {
					shared: false,
				},
			}
		},
	},

	mounted() {
		for (const item of this.data) {
			const [day, month, year] = item.date.split("-")
			const formattedDate = `${year}-${month}-${day}` // Convert to YYYY-MM-DD
			const timestamp = new Date(`${formattedDate} ${item.hour}`).getTime()
			this.GPOAiData.push({
				x: item['ts'],
				y: item['value'],
			})
		}
	},

	methods: {
		changeEnergyFrom() {
			this.xMin = new Date(this.dateFrom).getTime()
		},
		changeEnergyTo() {
			this.xMax = new Date(this.dateTo).getTime()
		},
	},
})
</script>